module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/agata-szatecka-aefd4bcf041595977c1d12ece74e4345.webp";